import api from "./api"

export const USER_LS_ = "V1_asa_user"
export const TOKEN_LS_ = "V1_asa_token";

export const onLogin = (email: string, password: string) => {
  const bodyFormData = new FormData();
  bodyFormData.append("login", email);
  bodyFormData.append("pass", password);

  return api.post("/login", bodyFormData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const setUser = (_u: string) => {
  localStorage.setItem(USER_LS_, _u);
};

export const setToken = (_t: string) => {
  localStorage.setItem(TOKEN_LS_, _t);
};

export const getMe = () => {
  return localStorage.getItem(TOKEN_LS_) ? true : false;
};

export const onLogout = () => {
  try {
    localStorage.removeItem(USER_LS_);
    localStorage.removeItem(TOKEN_LS_);
    return true;
  } catch (error) {}
};
